import React from "react";
import {
  SimpleForm,
  TextInput,
  SelectInput,
  SaveButton,
  required,
  minLength,
  maxLength,
  ReferenceInput,
} from "react-admin";
import { Grid, Button } from "@mui/material";
import { GenderOptionsId } from "utils/choices";
import CloseIcon from "@mui/icons-material/Close";
import { administrationRequests } from "api/administrationApi";

const UserInfoForm = ({ handleChange, handleSaveClick, setIsUserInfoEditing, isBg = true }) => {
  return (
    <SimpleForm toolbar={false}>
      <Grid
        container
        spacing={3}
      >
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Име"
            source="info.firstName"
            validate={[required(), minLength(2), maxLength(30)]}
            onChange={e => handleChange("firstName", e.target.value)}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Презиме"
            source="info.secondName"
            validate={[minLength(2), maxLength(30)]}
            onChange={e => handleChange("secondName", e.target.value)}
          />
        </Grid>
        <Grid
          item
          xs={12}
          md={4}
        >
          <TextInput
            label="Фамилия"
            source="info.lastName"
            validate={[required(), minLength(2), maxLength(30)]}
            onChange={e => handleChange("lastName", e.target.value)}
          />
        </Grid>
        {isBg ? (
          <>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                label="ЕГН"
                source="info.personId"
                onChange={e => handleChange("personId", e.target.value)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                label="Телефон за контакт"
                source="info.contactPhone"
                onChange={e => handleChange("contactPhone", e.target.value)}
              />
            </Grid>
          </>
        ) : (
          <>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                label="Име (латиница)"
                source="info.firstNameEn"
                validate={[required(), minLength(2), maxLength(30)]}
                onChange={e => handleChange("firstNameEn", e.target.value)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                label="Презиме (латиница)"
                source="info.secondNameEn"
                validate={[minLength(2), maxLength(30)]}
                onChange={e => handleChange("secondNameEn", e.target.value)}
              />
            </Grid>
            <Grid
              item
              xs={12}
              md={4}
            >
              <TextInput
                label="Фамилия (латиница)"
                source="info.lastNameEn"
                validate={[required(), minLength(2), maxLength(30)]}
                onChange={e => handleChange("lastNameEn", e.target.value)}
              />
            </Grid>
          </>
        )}
        <Grid
          item
          xs={12}
          md={4}
        >
          <SelectInput
            label="Пол"
            source="info.gender"
            choices={GenderOptionsId}
            validate={[required()]}
            onChange={e => handleChange("gender", e.target.value)}
          />
        </Grid>
        {!isBg && (
          <Grid
            item
            xs={12}
            md={4}
          >
            <ReferenceInput
              source="info.residenceCountryId"
              reference={administrationRequests.getCountriesSelect()}
              emptyText="-"
            >
              <SelectInput
                label="Държава"
                optionText="nameBg"
                onChange={e => handleChange("residenceCountryId", e.target.value)}
              />
            </ReferenceInput>
          </Grid>
        )}
      </Grid>
      <Grid sx={{ display: "flex", gap: 3 }}>
        <Button
          variant="outlined"
          startIcon={<CloseIcon />}
          color="error"
          onClick={() => setIsUserInfoEditing(false)}
        >
          Откажи
        </Button>
        <SaveButton
          label="Запази"
          onClick={handleSaveClick}
        />
      </Grid>
    </SimpleForm>
  );
};

export default UserInfoForm;
